export interface IEpisodeOfCareSummaryResult {
  episodeOfCareId: string | undefined
  bodyPart: string
  careCoordinatorName: string
  generatedNumberOrLegacy: string
  organizationName: string
  organizationId: string
  referralDateDisplay: string
  status: string
  surgeryDateDisplay: string
  takeoverOfCare: string
  lastMMIDateDisplay: string
  billingNotes: string
}

export class EpisodeOfCareSummaryResult implements IEpisodeOfCareSummaryResult {
  public episodeOfCareId: string | undefined
  public bodyPart: string
  public careCoordinatorName: string
  public generatedNumberOrLegacy: string
  public organizationName: string
  public organizationId: string
  public referralDateDisplay: string
  public status: string
  public surgeryDateDisplay: string
  public takeoverOfCare: string
  public lastMMIDateDisplay: string
  public billingNotes: string
}
